
import React, { useEffect, useState } from "react";
import "./CategoryPage.scss"
import arrow from "../../../assets/arrow-right-black.svg"
import arrow2 from "../../../assets/arrow-black.svg"
import redo from "../../../assets/redo.svg"
import search from "../../../assets/search.svg"
import popular from "../../../assets/filters/popular.svg"
import rate from "../../../assets/filters/rated.svg"
import highest from "../../../assets/filters/more.svg"
import lowest from "../../../assets/filters/less.svg"
import list from "../../../assets/listview.svg"
import grid from "../../../assets/gridview.svg"
import { useHistory, useParams } from "react-router"
import Pagination from "../../../components/Pagination/Pagination";
import { getLocalStorageData, LOCAL_STORAGE_ITEMS_NAMES } from "../../../../../../utilities/helper";
import { getFilteredData } from "../../../../../../utilities/apiRequests/witmegRetailPaxServerRequests";
import { useSelector } from "react-redux";
import { getAllData } from "../../../../../../../../redux/resturantWidgetSlice";
import LayoutTemplateV3 from "../../../components/layouts/LayoutTemplateV3";
import FilterComponent from "../../../components/FilterComponent/FilterComponent";
const getData = async () => {
    const result = await getAllData();

    const allItems = Array.isArray(result?.data?.Items) ? result.data.Items : [];
    const allCategories = Array.isArray(result?.data?.Categories) ? result.data.Categories : [];

    const categories = allCategories.filter(
        (category) => !category.MetaData?.ShowAsOffer
    );

    const itemIDs = categories.flatMap(
        (category) => category.MenuEntities?.map(entity => entity.ID) || []
    );

    const items = allItems.filter(item =>
        itemIDs.includes(item.MenuItemID)
    );

    return items;
};
const CategoryPageV4 = ({ selected, setSelected }) => {
    const history = useHistory()
    let params = useParams();

    const sortList = [
        {
            label: "Most Popular",
            icon: popular,
            value: "popular"
        },
        {
            label: "Highest Rated",
            icon: rate,
            value: "rated",
        }, {
            label: "Price: Low to High",
            icon: highest,
            value: "price-asc",
        }, {
            label: "Price: High to Low",
            icon: lowest,
            value: "price-desc",
        },
    ]
    const [data, setData] = useState([])
    const [totalItems, setTotalItems] = useState(data.length);
    const [itemsData, setItemsData] = useState(data);
    const [menuData, setMenuData] = useState(itemsData?.slice(0, 6))
    const [categories, setCategories] = useState([])

    const [searchValue, setSearchValue] = useState("")
    const [sort, setSort] = useState(sortList[0])
    const [filters, setFilters] = useState([])
    const [currentPage, setCurrentPage] = useState(1);
    const [priceRange, setPriceRange] = useState({ min: 0, max: 50 })
    const itemsPerPage = 6
    const [isLoading, setIsLoading] = useState(true);
    const [pageLoading, setPageLoading] = useState(true);

    const [showFilters, setShowFilters] = useState(false)
    const [view, setView] = useState("LIST")
    const [viewAll, setViewAll] = useState(false)


    const {
        selectedOrderType
    } = useSelector((state) => state.resturantData);
    useEffect(() => {
        const fetchData = async () => {
            const items = await getData();
            setData(items);
            setItemsData(items)
            setMenuData(items?.slice(0, 6))
            setTotalItems(items?.length)
        };

        fetchData();
    }, [])
    useEffect(() => {
        getAllData().then((result) => {
            let cat = result?.data?.Categories?.filter(
                (category) => !category.MetaData?.ShowAsOffer
            );
            setCategories(cat)
            setPageLoading(false)
        });
    }, []);

    const getType = () => {
        let type;
        switch (selectedOrderType) {
            case "delivery":
                type = "DeliverybyConsumerDriver";
                break;
            case "table":
                type = "DineIn";
                break;
            case "collection":
                type = "TakeAway";
                break;
            default:
                type = "DeliverybyConsumerDriver";
                break;
        }

        return type;
    };
    const handleData = () => {
        setIsLoading(true)
        if (selected) {
            let menuIds = selected.MenuEntities?.map(entity => entity.ID)
            const promotionalItems = data.filter(item =>
                menuIds.includes(item.MenuItemID)
            );
            if (searchValue === "") {
                setItemsData(promotionalItems)
                setMenuData(promotionalItems.slice(0, 6))
                setTotalItems(promotionalItems.length)
            } else {
                const searchedItems = promotionalItems.filter(item =>
                    item.Title.en.toLowerCase().includes(searchValue.toLowerCase())
                );
                setItemsData(searchedItems)
                setMenuData(searchedItems.slice(0, 6))
                setTotalItems(searchedItems.length)
            }
            setCurrentPage(1)
            setIsLoading(false)

        } else {
            const updatedArray = categories.map((item) => ({
                ...item,
                MenuEntities: item.MenuEntities.slice(0, 3),
            }));

            const menuIds = updatedArray.flatMap(item =>
                item.MenuEntities.map(entity => entity.ID)
            );

            const promotionalItems = data.filter(item =>
                menuIds.includes(item.MenuItemID)
            );
            if (searchValue === "") {
                setItemsData(promotionalItems)
                setMenuData(promotionalItems.slice(0, 6))
                setTotalItems(promotionalItems.length)
            } else {
                const searchedItems = promotionalItems.filter(item =>
                    item.Title.en.toLowerCase().includes(searchValue.toLowerCase())
                );
                setItemsData(searchedItems)
                setMenuData(searchedItems.slice(0, 6))
                setTotalItems(searchedItems.length)
            }
            setCurrentPage(1)
            setIsLoading(false)

        }
    }
    useEffect(() => {
        handleData()
    }, [selected, searchValue])

    useEffect(() => {
        if (filters.length > 0 || sort.value !== "popular" || (priceRange.min !== 0 && priceRange.max !== 50)) {
            // fetchData()
        } else {
            handleData()
        }
    }, [sort, priceRange, filters, searchValue, selected])
    const fetchData = async () => {
        const val = await getLocalStorageData(LOCAL_STORAGE_ITEMS_NAMES.ECOM_CART_DATA);
        const userId = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID) ?? "";
        const countObj = {
            CloudLocationID: val.cloudLocationID,
            OrganizationID: val.organizationID,
            CategoryID: selected?.MenuCategoryID || "",
            UserID:
                localStorage.getItem("isLogged") === "true" ? userId : "",
            SearchTerm: searchValue?.toLowerCase() || "",
            SortBy: sort?.value || "",
            PriceMin: priceRange.min * 100,
            PriceMax: priceRange.max * 100,
            IsHalal: filters.filter((fil) => fil.type === "DIET").some((it) => it.name === "Halal") ?? false,
            IsGlutenFree: filters.filter((fil) => fil.type === "DIET").some((it) => it.name === "Gluten-Free") ?? false,
            IsVegetarian: filters.filter((fil) => fil.type === "DIET").some((it) => it.name === "Vegetarian") ?? false,
            IsSpicy: filters.filter((fil) => fil.type === "DIET").some((it) => it.name === "Spicy") ?? false,
            FullFilmentType: getType(),
            PageNumber: currentPage,
            ItemsPerPage: itemsPerPage,
        };

        try {
            setIsLoading(true)

            let responsse = await getFilteredData(countObj)
            if (responsse) {
                setMenuData(responsse.data.Items)
                setTotalItems(responsse.total)
                setIsLoading(false)
            }

        } catch (error) {
            console.error("Error fetching data:", error);
            setIsLoading(false)
        }
    };
    const types = [
        {
            type: "LIST",
            icon: list
        },

        {
            type: "GRID",
            icon: grid
        },

    ]
    return (
        <div className="CategoryPageV4" id="CategoryPageV4">
            {pageLoading ? <div className="loader-cont">
                <div className="loader-lay" /></div> :
                <>
                    {showFilters ? <FilterComponent
                        filters={filters}
                        setFilters={setFilters}
                        sort={sort}
                        setSort={setSort}
                        rangeValue={{
                            Min: 0,
                            Max: 50
                        }}
                        sortList={sortList}
                        setSelected={setSelected}
                        setPriceRange={setPriceRange}
                        priceRange={priceRange}
                        setShowFilters={setShowFilters}
                        fetchData={() => {
                            if (filters.length > 0 || sort.value !== "popular" || (priceRange.min !== 0 && priceRange.max !== 50)) {
                                fetchData()
                            }
                        }}
                    /> : ""}
                    <div className="header-contentcontainertop">
                        {selected ? <div className="header-contentcontainertop-right"
                            onClick={() => {
                                setSelected(null)
                                localStorage.setItem("selected_cat", "null")
                            }} >
                            <img alt="" src={arrow} className="back-arr"
                            /> Back
                        </div> : viewAll && <div className="header-contentcontainertop-right"
                            onClick={() => {
                                setViewAll(false)
                                setCurrentPage(1)
                                setMenuData(itemsData.slice(0, 6));

                            }} >
                            <img alt="" src={arrow} className="back-arr"
                            /> Back
                        </div>}
                        {(selected || (!selected && viewAll)) && <div className="header-contentcontainertop-left">
                            <div className="header-contentcontainertop-left-view">
                                {types.map((type, idx) => {
                                    return (
                                        <div
                                            onClick={() => {
                                                setView(type.type)
                                            }}
                                            key={idx} className={view === type.type ? "header-contentcontainertop-left-view-typeselected" : "header-contentcontainertop-left-view-type"}>
                                            <img alt="" src={type.icon} />
                                        </div>
                                    )
                                })}

                            </div>
                            <div
                                className="header-contentcontainertop-left-filter"
                                onClick={() => {
                                    setShowFilters(!showFilters)
                                }}
                            >
                                Filter
                                <img alt="" src={arrow2} /></div>
                        </div>}

                    </div>
                    <div className="header-contentcontainer ">

                        <div className="heder-text-cont">
                            <div className="header-txt">
                                {selected ? selected?.Title?.en?.toLowerCase() :
                                    "Recommended For You"}</div>

                        </div>
                        {!selected && !viewAll &&
                            <div className="header-contentcontainer-viewall"
                                onClick={() => {
                                    setViewAll(true)
                                }}>See All
                                <img alt="" src={arrow2} /></div>}
                    </div>


                    {isLoading ?
                        <div className="loader-cont">
                            <div className="loader-lay" /></div>
                        :
                        menuData.length > 0 ? <div className="items-layout">
                            <LayoutTemplateV3
                                layout={view}
                                items={
                                    menuData || []
                                }
                                showHeader={false}
                                from={"CATEGORY"}
                                setItems={setMenuData}
                                currentPage={currentPage + 1}
                                setTempData={setItemsData}
                                setAllData={setData}
                            />


                            {(selected || (!selected && viewAll)) && totalItems > 6 && <div className="pagination-containerV4">
                                <Pagination
                                    totalItems={totalItems}
                                    itemsPerPage={itemsPerPage}
                                    currentPage={currentPage}
                                    onPageChange={(e) => {
                                        setCurrentPage(e)
                                        setMenuData(itemsData.slice(6 * (e - 1), 6 * e));
                                    }}
                                />
                            </div>}

                        </div> : <div className="rec-empty">
                            <img alt="" src={search} className="empty-searc-ic" />
                            <div className="empt-hdr">No items found</div>
                            <div className="empt-sub-hdr">We couldn't find any items matching your search criteria. Try adjusting your filters or search terms.</div>
                            <div className="empt-rst-btn"
                                onClick={() => {
                                    setFilters([])
                                    setCurrentPage(1);
                                    setSearchValue("")
                                }}>
                                <img alt="" src={redo} className="rest-ico" />
                                Reset All Filters</div>
                        </div>
                    }
                </>}
        </div >
    )
}
export default CategoryPageV4